import React, { useState, useEffect } from 'react'
import Select, { components } from 'react-select'
import loadOptions, { optionsData } from './loadOptions'
import { SelectStyle, OptionsSelect } from './styled'
import ClassNames from 'classnames'
import moment from 'moment'
import {
  Button,
  Image,
  Input,
  Section,
  InputTextarea,
  Table,
  Modal,
  Checkbox,
  Tabber,
  DatePickerInput,
  SelectBox,
  Text,
  ToggleCompareEvent,
  Spinner,
} from '../../components'
import { rfqController, mySupplierCompanyController } from '../../apiService'

const ModalRequestUnseal = React.memo(
  ({
    modals,
    toggleModal,
    funcOpenModalConfirm,
    userTecContacts,
    loadingUserTecContacts,
    checkBoxAwaitingSubmit,
    modalsOpenReqUnseal,
    props,
    searchTec,
    fetchTecContacts,
    paginationTecContacts,
    modalSave,
    checkAllRequestUnseal,
    funcRemoveAll,
    renderTecTableContacts,
    dataInitTableTec,
  }) => {
    const [searchKeywords, setSearchKeywords] = useState('')
    const [objSetAll, setStateObjCheckAll] = useState(null)
    const Option = props => {
      const resultEmail = props.options.filter(
        word => word.label === props.label
      )
      return (
        <components.Option {...props}>
          <OptionsSelect>
            <div>
              <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
              />{' '}
            </div>
            <div>{props.label}</div>
            <div>{resultEmail[0].desc}</div>
          </OptionsSelect>
        </components.Option>
      )
    }
    const [value, onChange] = useState(null)
    const [dataInitCheck, setDataInitCheck] = useState([])
    const [optionsTecRole, setOptionsTecRole] = useState([])
    const [menuIsOpen, setMenuIsOpen] = useState(false)
    let refOptions = ''
    // fetch data
    useEffect(async () => {
      let mount = true
      const elmScroll = document.getElementById('sourcing_request_unseal')
      async function fetchTec() {
        let response = await fetchTecContacts(paginationTecContacts)
        if (response) {
          const mapArray = response.map((item, value) => {
            return item.is_request
          })
          setDataInitCheck([...mapArray])
        }
      }

      const eventListenerScroll = event => {
        if (
          elmScroll.scrollTop + elmScroll.clientHeight >=
          elmScroll.scrollHeight - 1
        ) {
          fetchTec()
        }
      }
      if (mount) {
        if (modalsOpenReqUnseal) {
          const fetchDataTec = async () => {
            const { match } = props
            const { id } = match.params
            const params = {
              idRfq: id ? id : '',
              search: '',
              page: 1,
            }
            const res = await rfqController().getRequestUserTec(params)
            if (res) {
              const dataResult = res.records.map((value, index) => {
                const data = {
                  value: value.id,
                  label: value.name,
                  desc: value.email,
                }
                return data
              })
              setOptionsTecRole([...dataResult])
            }
          }
          //fetchDataTec()
          // scroll fetch data table
          const funcScrollFetchDataTable = () => {
            elmScroll.addEventListener('scroll', eventListenerScroll)
          }
          funcScrollFetchDataTable()
        }
      }
      return () => {
        mount = false
      }
    }, [modalsOpenReqUnseal])
    const filterColors = inputValue => {
      if (optionsTecRole) {
        return optionsTecRole.filter(i =>
          i.label.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
    }
    const promiseOptions = inputValue => {
      new Promise(resolve => {
        setTimeout(() => {
          resolve(filterColors(inputValue))
        }, 3000)
      })
    }
    useEffect(() => {
      let mount = true
      if (mount) {
        if (userTecContacts) {
          const mapArray = userTecContacts.map((item, value) => {
            return item.is_request
          })
          setDataInitCheck([...mapArray])
        }
        if (modalsOpenReqUnseal === false) {
          setSearchKeywords('')
        }
      }
      return () => {
        mount = false
      }
    }, [userTecContacts, modalSave, modalsOpenReqUnseal])
    const handleOnClickCancel = e => {
      funcOpenModalConfirm(false)
    }
    const handleOnClick = e => {
      if (userTecContacts) {
        const dataResult = userTecContacts.filter(element => {
          if (element.request_at === '' && element.request_status !== '') {
            return element
          }
        })
        renderTecTableContacts(dataResult)
      }
      funcOpenModalConfirm('save data')
    }
    const handleOnChange = (position, id, data) => {
      // savePositionPrev
      if (dataInitCheck) {
        const updatedCheckedState = dataInitCheck.map((item, index) =>
          index === position ? !item : item
        )
        const findArrayCheck = dataInitCheck.find((item, index) => {
          if (index === position) {
            const result = !item
            if (result === true) {
              return 'check'
            } else {
              return 'uncheck'
            }
          }
        })
        setDataInitCheck(updatedCheckedState)
        if (findArrayCheck) {
          const obj = {
            is_request: false,
            id,
            save: false,
          }
          setStateObjCheckAll(obj)
          checkBoxAwaitingSubmit(obj)
        } else {
          const obj = {
            is_request: true,
            id,
            save: true,
          }
          setStateObjCheckAll(obj)
          checkBoxAwaitingSubmit(obj)
        }
      }
    }
    const renderFullName = (check, index) => {
      if (userTecContacts[index]) {
        return (
          <React.Fragment>
            <Checkbox
              key={userTecContacts[index].id}
              id={`${userTecContacts[index].id}`}
              value={check}
              checked={check}
              onChange={() =>
                handleOnChange(
                  index,
                  userTecContacts[index].id,
                  userTecContacts[index]
                )
              }
              disabled={userTecContacts[index].request_at !== '' && true}
            />
          </React.Fragment>
        )
      }
    }
    // renderEmail
    const renderEmail = index => {
      if (userTecContacts[index]) {
        const renderText = () => {
          return (
            <Text
              tootipValue={userTecContacts[index].email}
              useTootipFor="date-email"
              useTootip={true}
            >
              {userTecContacts[index].email}
            </Text>
          )
        }
        return <React.Fragment>{renderText()}</React.Fragment>
      }
    }
    // renderFullName
    const renderFullNameNotCheck = index => {
      if (userTecContacts[index]) {
        const renderText = () => {
          return (
            <Text
              tootipValue={userTecContacts[index].name}
              useTootipFor="date-fullname"
              useTootip={true}
            >
              {userTecContacts[index].name}
            </Text>
          )
        }
        return <React.Fragment>{renderText()}</React.Fragment>
      }
    }
    const renderTecContacts = data => {
      if (data.length >= 1) {
        return data.map((check, index) => {
          return (
            <React.Fragment key={index}>
              <Table.TR>
                <Table.TD className="requestunseal_date">
                  {renderFullName(check, index)}
                </Table.TD>
                <Table.TD className="requestunseal_fullname">
                  {renderFullNameNotCheck(index)}
                </Table.TD>
                <Table.TD className="requestunseal_email">
                  {renderEmail(index)}
                </Table.TD>
              </Table.TR>
            </React.Fragment>
          )
        })
      } else if (data.length <= 0) {
        return (
          <React.Fragment key={`empty_dat${data[0]}`}>
            <Table.TR>
              <div
                style={{
                  display: 'flex',
                  marginTop: '2em',
                  fontSize: '1.5em',
                  width: '100%',
                  justifyContent: 'center',
                }}
              >
                <h3>Data not found</h3>
              </div>
            </Table.TR>
          </React.Fragment>
        )
      }
    }
    const openMenu = () => {
      setMenuIsOpen(true)
    }
    const openClose = () => {
      setMenuIsOpen(false)
    }
    const menuPortalTargettest = document.getElementById('root')
    useEffect(() => {
      let mount = true
      if (mount) {
        if (menuIsOpen) {
          optionsData(optionsTecRole)
        }
      }
      return () => {
        mount = false
      }
    }, [menuIsOpen])
    const onChangeSearchText = e => {
      setSearchKeywords(e.target.value)
    }
    const clickSearchText = () => {
      searchTec(searchKeywords)
    }
    const ScrollToBottom = () => {
      const fetchDataTec = async () => {
        const { match } = props
        const { id } = match.params
        const params = {
          idRfq: id ? id : '',
          search: '',
          page: 2,
        }
        const res = await rfqController().getRequestUserTec(params)
        if (res) {
          const dataResult = res.records.map((value, index) => {
            const data = {
              id: value.id,
              label: value.email,
            }
            return data
          })
          setOptionsTecRole(prevArray => [...prevArray, ...dataResult])
        }
      }
      fetchDataTec()
    }
    const onWheel = e => {
      e.stopPropagation()
    }
    const sleep = ms => {
      new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    }
    const loadOptions = async (search, prevOptions) => {
      await sleep(1000)
      const options = optionsTecRole
      let filteredOptions
      if (!search) {
        if (options) {
          filteredOptions = options
        }
      } else {
        const searchLower = search.toLowerCase()
        filteredOptions = options.filter(({ label }) =>
          label.toLowerCase().includes(searchLower)
        )
      }
      const hasMore = filteredOptions.length > prevOptions.length + 10
      const slicedOptions = filteredOptions.slice(
        prevOptions.length,
        prevOptions.length + 10
      )
      return {
        options: slicedOptions,
        hasMore,
      }
    }
    return (
      <React.Fragment>
        <Modal
          id="request_unseal"
          className="request-unseal theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'request-unseal'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Request to Unseal</Modal.Header>
          <Modal.Body>
            <Section className="form-group">
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper modalInput">
                  <Input
                    id="search-tec"
                    type="text"
                    name="search-tec"
                    value={searchKeywords}
                    placeholder="Full name, Email."
                    onChange={onChangeSearchText}
                  />
                  <Button className="theme-blue" onClick={clickSearchText}>
                    Search
                  </Button>
                </Section>
              </Section>
            </Section>
            <Section
              className="popup-sourcing table-header-freeze-wrapper"
              id="sourcing_request_unseal"
            >
              <Table className="sourcing">
                <Table.THEAD>
                  <Table.TR>
                    <Table.TH className="requestunseal_date">
                      <span></span>
                    </Table.TH>
                    <Table.TH className="requestunseal_email">
                      FULL NAME
                    </Table.TH>
                    <Table.TH className="requestunseal_email">EMAIL</Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>
                  {loadingUserTecContacts ? (
                    <Spinner />
                  ) : (
                    renderTecContacts(dataInitCheck)
                  )}
                </Table.TBODY>
              </Table>

              <Table className="sourcing split-row-color"></Table>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Section className="form-actions">
              <Section className="button-group modalUnsealButton">
                <Button
                  onClick={handleOnClickCancel}
                  className="theme-border-gray"
                >
                  Cancel
                </Button>
                <Button className="theme-green" onClick={handleOnClick}>
                  Ok
                </Button>
              </Section>
            </Section>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
)
ModalRequestUnseal.defaultProps = {
  modals: [],
  toggleModal: () => {
    return false
  },
  funcOpenModalConfirm: () => {
    return false
  },
  userTecContacts: [],
  loadingUserTecContacts: null,
  checkBoxAwaitingSubmit: () => {
    return false
  },
  modalsOpenReqUnseal: false,
  props: null,
  searchTec: () => {
    return false
  },
  fetchTecContacts: () => {
    return false
  },
  paginationTecContacts: {},
}
export default ModalRequestUnseal
